import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(7, 0),
    '& > div:not(:first-child)': {
      marginLeft: theme.spacing(5),
    },
  },
  legendEntry: {
    ...theme.typography.body1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.palette.facet.primaryGray,
  },
  legendBubble: {
    width: 19,
    height: 19,
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
  greenBubble: {
    backgroundColor: theme.palette.facet.accentGreen2,
  },
  blueBubble: {
    backgroundColor: theme.palette.facet.accentBlue11,
  },
  redBubble: {
    backgroundColor: theme.palette.facet.red,
  },
});

const CalendarLegend = ({
  className,
  classes,
}) => {
  return (
    <div className={classNames(className, classes.root)}>
      <div className={classes.legendEntry}>
        <div className={classNames(classes.legendBubble, classes.greenBubble)} />
        More than two available times
      </div>
      <div className={classes.legendEntry}>
        <div className={classNames(classes.legendBubble, classes.blueBubble)} />
        One or two available times
      </div>
      <div className={classes.legendEntry}>
        <div className={classNames(classes.legendBubble, classes.redBubble)} />
        No availability
      </div>
    </div>
  );
};

CalendarLegend.defaultProps = {
  className: '',
};

CalendarLegend.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CalendarLegend);
